import { AddIcon, ChevronRightIcon } from '@treams/treams-icons';
import { Button, Separator, Subheading } from '@treams/treams-ui';
import { PropsWithChildren } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

const SidebarHeaderAccessory = styled(Box)`
	position: absolute;
	top: 12px;
	right: 0;
`;

const Rotation = styled(Box)<{ rotate: string }>`
	transform: rotate(${(props) => props.rotate});
	transition: transform 200ms ease-out;
`;

export default function SidebarSectionHeader(
	props: PropsWithChildren<{ onClick?: () => void; isOpen?: boolean; createLink?: string }>,
) {
	return (
		<Box style={{ position: 'relative' }}>
			{props.createLink && (
				<SidebarHeaderAccessory>
					<Button type="transparent" small icon={<AddIcon />} link={props.createLink} />
				</SidebarHeaderAccessory>
			)}
			<Box
				onClick={() => props.onClick?.()}
				style={{ cursor: props.onClick ? 'pointer' : 'default' }}
			>
				<Separator mx={-3} />
				<Flex alignItems="center" my={3}>
					{props.isOpen !== undefined && (
						<Rotation width={24} mr={2} rotate={props.isOpen ? '90deg' : '0deg'}>
							<ChevronRightIcon />
						</Rotation>
					)}
					<Subheading width="100%">
						<Flex width="100%" justifyContent="space-between" alignItems="center">
							{props.children}
						</Flex>
					</Subheading>
				</Flex>
			</Box>
		</Box>
	);
}
